export default function getSlug() {
  return window.location.pathname.split("/")[1];
}
